import {useEffect, useState} from 'react';
import type {SelfEmploymentProvider} from '@rocket-ui/lk-api';

const STORAGE_KEY = 'lk-alfa-agreement-opened';
const OPENED_EVENT = 'lk-alfa-agreement-opened';

const storageKey = (provider: SelfEmploymentProvider = 'alfa'): string => {
	return provider === 'alfa' ? STORAGE_KEY : `${STORAGE_KEY}:${provider}`;
};

/** Пользователь уже открывал фрейм соглашения — на списке показываем ошибку, пока не подпишет. */
export const markAlfaAgreementFrameOpened = (provider: SelfEmploymentProvider = 'alfa'): void => {
	try {
		localStorage.setItem(storageKey(provider), '1');
	} catch {
		/* private mode */
	}

	window.dispatchEvent(new Event(OPENED_EVENT));
};

export const clearAlfaAgreementFrameOpened = (provider: SelfEmploymentProvider = 'alfa'): void => {
	try {
		localStorage.removeItem(storageKey(provider));
	} catch {
		/* ignore */
	}

	window.dispatchEvent(new Event(OPENED_EVENT));
};

export const hasAlfaAgreementFrameOpened = (provider: SelfEmploymentProvider = 'alfa'): boolean => {
	try {
		return localStorage.getItem(storageKey(provider)) === '1';
	} catch {
		return false;
	}
};

export const useAlfaAgreementFrameOpened = (provider: SelfEmploymentProvider = 'alfa'): boolean => {
	const [opened, setOpened] = useState(() => hasAlfaAgreementFrameOpened(provider));

	useEffect(() => {
		const sync = () => setOpened(hasAlfaAgreementFrameOpened(provider));

		sync();
		window.addEventListener(OPENED_EVENT, sync);
		window.addEventListener('storage', sync);

		return () => {
			window.removeEventListener(OPENED_EVENT, sync);
			window.removeEventListener('storage', sync);
		};
	}, [provider]);

	return opened;
};
